import SVGIconWrapper from "./SVGIconWrapper"

const IconCheckmarkCircleAlt = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 213.34 212"
        iconClass={`icon--checkmark-circle-alt ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M106 212a106 106 0 1 1 71.87-183.92 5 5 0 0 1-6.78 7.35 95.74 95.74 0 1 0 22.05 30.23 5 5 0 1 1 9.07-4.21A106 106 0 0 1 106 212z" /><path d="M99.6 139.1a5 5 0 0 1-3.54-1.46l-43-43a5 5 0 0 1 7.07-7.07L99.6 127 204.81 21.82a5 5 0 1 1 7.07 7.07L103.14 137.63a5 5 0 0 1-3.54 1.47z" />
    </SVGIconWrapper>
)

export default IconCheckmarkCircleAlt